export default __webpack_public_path__ + "static/media/appointment.b0558959.svg";